import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { formatDate, formatPrice, paymentMethodLabel, sortPaymentsByDueDate } from './reservationUtils';
import ReservationSummary from './ReservationSummary';
import ReservationCustomerDetails from './ReservationCustomerDetails';
import ReservationPriceBreakdown from './ReservationPriceBreakdown';
import PendingPaymentNextSteps from './PendingPaymentNextSteps';

const ReservationDetails = ({
  order,
  roomName,
  payments,
  bankTransferConfig,
  showPaymentMethodColumn = false,
  showConfirmationNumber = false,
  showPaymentSchedule = true,
}) => {
  const allPayments = sortPaymentsByDueDate(payments ?? []);

  return (
    <>
      <ReservationSummary
        order={order}
        roomName={roomName}
        showConfirmationNumber={showConfirmationNumber}
        showTotalPrice={false}
      />

      <ReservationCustomerDetails order={order} />

      <ReservationPriceBreakdown order={order} roomName={roomName} />

      <PendingPaymentNextSteps
        order={order}
        payments={payments}
        bankTransferConfig={bankTransferConfig}
      />

      {showPaymentSchedule && (
        <>
          <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
            Harmonogram płatności
          </Typography>
          <Paper variant="outlined" sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
            {allPayments.length === 0 ? (
              <Box sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Brak wygenerowanych płatności dla tej rezerwacji.
                </Typography>
              </Box>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Termin płatności</TableCell>
                    <TableCell align="right">Kwota</TableCell>
                    <TableCell>Status</TableCell>
                    {showPaymentMethodColumn && <TableCell>Metoda / data zapłaty</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allPayments.map((p) => (
                    <TableRow key={p.id}>
                      <TableCell>{formatDate(p.dueDate)}</TableCell>
                      <TableCell align="right">{formatPrice(p.amountDue)}</TableCell>
                      <TableCell>
                        {p.paidDate ? (
                          <Chip
                            label={p._optimistic ? 'W trakcie' : 'Opłacono'}
                            color={p._optimistic ? 'info' : 'success'}
                            size="small"
                          />
                        ) : (
                          <Chip label="Do zapłaty" color="warning" size="small" />
                        )}
                      </TableCell>
                      {showPaymentMethodColumn && (
                        <TableCell>
                          {p.paidDate && !p._optimistic
                            ? `${paymentMethodLabel(p.paymentMethod)} – ${formatDate(p.paidDate)}`
                            : p._optimistic
                            ? 'PayU – oczekiwanie na potwierdzenie'
                            : '—'}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Paper>
        </>
      )}
    </>
  );
};

export default ReservationDetails;
